import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { z } from 'zod';

import { AuthLayout } from '@cold-ambulance/layout';
import { Button, CardContent, Input, Label } from '@cold-ambulance/shadcn';
import { resetPasswordViaEmail } from '@cold-ambulance/ui';

import { auth } from '../../firebase.tsx';

export default function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const navigate = useNavigate();
  const mutation = useMutation({
    mutationKey: ['reset-password'],
    mutationFn: async () => {
      if (z.string().email().safeParse(email).success) {
        await resetPasswordViaEmail(auth, email);
      } else {
        throw new Error('البريد الإلكتروني غير صحيح');
      }
    },
    onSuccess: () => navigate('/reset-password-email-sent'),
  });

  return (
    <AuthLayout
      className="bg-[#F8F8F8]"
      title={t('forgotPassword.title')}
      subtitle={t('forgotPassword.subtitle')}
      center={true}
    >
      <CardContent className="px-0">
        <div className="flex flex-col gap-2">
          <Label htmlFor="email" className="text-sm font-medium">
            {t('common.email')}
          </Label>
          <Input
            id="email"
            dir="ltr"
            type="email"
            placeholder="me@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full"
          />
        </div>
        <Button
          type="button"
          onClick={() => mutation.mutate()}
          disabled={!email || mutation.isPending}
          className="mt-7 w-full"
        >
          {mutation.isPending ? t('common.processing') : <>{t('common.send')}</>}
        </Button>
        {mutation.error && (
          <p className="text-sm text-red-500">
            {(mutation.error as Error).message}
          </p>
        )}
      </CardContent>
    </AuthLayout>
  );
}
